var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavPanelLink',{class:_vm.$style.link,attrs:{"active":_vm.isActive,"activeLink":_vm.activeLink,"item":_vm.item,"panelExpanded":_vm.panelExpanded}})
}
var staticRenderFns = []

export { render, staticRenderFns }